import React, { createContext, useContext, useMemo } from 'react';

export const CompetitionsContext = createContext(null);

export const useCompetitionsContext = () => useContext(CompetitionsContext);

export const CompetitionsProvider = ({ children, competitions }) => {
  const state = useMemo(() => ({ competitions }), [competitions]);

  return <CompetitionsContext.Provider value={state}>{children}</CompetitionsContext.Provider>;
};
